import { getInitials, getColorFromName } from "./constants";

// ============================================================================
// OWNER BUBBLE COMPONENT
// ============================================================================

export default function OwnerBubble ({ owner, size = 24, onClick }) {
  const initials = getInitials(owner);
  const bgColor = getColorFromName(owner);
  
  return (
    <div
      onClick={onClick}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: bgColor,
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.4,
        fontWeight: 600,
        cursor: onClick ? "pointer" : "default",
        flexShrink: 0,
        border: "2px solid rgba(255,255,255,0.3)",
        userSelect: "none",
      }}
      title={owner}
    >
      {initials}
    </div>
  );
}
